import React from "react";

const DrugTable = ({ drugTable, setDrugTable }) => {
  const handleInputChange = (rowIndex, field, value) => {
    const updatedData = [...drugTable];
    updatedData[rowIndex][field] = value;
    setDrugTable(updatedData);
  };

  const addRow = () => {
    setDrugTable([
      ...drugTable,
      {
        inn: "",
        brandName: "",
        formulation: "",
        strength: "",
        therapeuticArea: "",
      },
    ]);
  };

  const removeRow = () => {
    if (drugTable.length > 1) {
      setDrugTable(drugTable.slice(0, -1));
    }
  };

  return (
    <div>
      <div style={{ marginTop: "20px", border: "1px solid #000", borderRadius: "8px", overflow: "hidden", width: "100%" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#d0c5ca", color: "#000" }}>
              <th style={tableHeaderStyle}>International Non-Proprietary Name (INN)</th>
              <th style={tableHeaderStyle}>Brand Name (if applicable)</th>
              <th style={tableHeaderStyle}>Formulation (e.g., tablet, capsule)</th>
              <th style={tableHeaderStyle}>Strength</th>
              <th style={tableHeaderStyle}>WHO Therapeutic Area (e.g., HIV, malaria)</th>
            </tr>
          </thead>
          <tbody>
            {drugTable.map((row, index) => (
              <tr key={index}>
                {[
                  "inn",
                  "brandName",
                  "formulation",
                  "strength",
                  "therapeuticArea",
                ].map((field) => (
                  <td key={field} style={tableCellStyle}>
                    <input
                      type="text"
                      value={row[field]}
                      onChange={(e) => handleInputChange(index, field, e.target.value)}
                      style={inputFieldStyle}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: "flex", justifyContent: "center", marginTop: "10px", gap: "10px" }}>
        <button onClick={removeRow} style={removeButtonStyle}>- Remove</button>
        <button onClick={addRow} style={addButtonStyle}>+ Add More</button>
      </div>
    </div>
  );
};

// Reuse existing styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default DrugTable;
